  import { put, call } from "redux-saga/effects";
  import {ActionConstants, ApiConstants} from "../constants";
  import axios from "axios";

  export default function* resendVerificationSmsSaga(data) {
    try {
      const result = yield call(resendVerificationSmsApi, data.payload);

      if (result == null || result.status !== 1) {
        yield put({
          type: ActionConstants.RESEND_VERIFICATION_SMS_ACTION_FAILURE,
          payload: {
            result: result != null ? result.error : null,
          },
        });
      } else {
        yield put({
          type: ActionConstants.RESEND_VERIFICATION_SMS_ACTION_SUCCESS,
          payload: {
            result: result.data,
          },
        });
      }
    } catch (e) {
      yield put({
        type: ActionConstants.RESEND_VERIFICATION_SMS_ACTION_FAILURE,
        payload: {
          result: e,
        },
      });
    }
  }

  const resendVerificationSmsApi = params => {
    const url = ApiConstants.URI_FE + ApiConstants.API_RESEND_VERIFICATION_SMS;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(response => response.data);
  };
